<template>
  <div class="c-checkbox">
    <div class="c-checkbox__checkbox" @click="$emit('input', !value)">
      <div v-if="value" class="c-checkbox__checkbox__checked"></div>
    </div>
    <p class="c-checkbox__privacy__desc">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    text: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.c-checkbox {
  display: flex;
  align-items: center;
}
.c-checkbox__checkbox {
  min-width: 20px;
  min-height: 20px;
  border: 1px solid #8a8497;
  border-radius: 3px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.c-checkbox__privacy__desc {
  margin-bottom: 0;
  color: #8a8497;
}
.c-checkbox__checkbox__checked {
  width: 16px;
  height: 16px;
  background-color: #0cbf08;
  border-radius: 3px;
}
</style>
